import { api } from './client';
import { Album } from '../types/entities/album.entity';
import { AlbumResponse, AlbumsResponse } from '../types/responses/albums.responses';

export const albumService = {
    getAll: async (page: number = 1) => {
        const response = await api.get<AlbumsResponse>(`/albums?page=${page}&per_page=50`);
        return response.data;
    },

    getOne: async (id: string) => {
        const response = await api.get<AlbumResponse>(`/albums/${id}`);
        return response.data;
    },

    create: async (name: string) => {
        const response = await api.post<AlbumResponse>('/albums', { name });
        return response.data;
    },

    delete: async (id: string) => {
        await api.delete(`/albums/${id}`);
    },

    attachImages: async (albumId: string, imageIds: string[]) => {
        const response = await api.post<AlbumResponse>(`/albums/${albumId}/images`, {
            image_ids: imageIds,
        });
        return response.data;
    },

    detachImage: async (albumId: string, imageId: string) => {
        const response = await api.delete<AlbumResponse>(`/albums/${albumId}/images/${imageId}`);
        return response.data;
    },
};

export type { Album };
